// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Comments__button-c427ef {
  margin-inline-start: 11px;
}

.Comments__button-c427ef > span {
  min-width: 0px;
  padding-inline-start: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Footer/Comments/styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;AACF","sourcesContent":[".button {\n  margin-inline-start: 11px;\n}\n\n.button > span {\n  min-width: 0px;\n  padding-inline-start: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Comments__button-c427ef`
};
module.exports = ___CSS_LOADER_EXPORT___;
